module.exports = __webpack_public_path__ + "static/media/BadgeD.064afe47.svg";